/*
 *
 * File: users_reducer.js
 *
 * Purpose: User data reducer.
 *
 * Author:  Thomas Burgard (Software development)
 * Created: 23.02.2022
 *
 * Copyright (c) DrivePartner GmbH 2022
 *
 */

import { GET_USERDATA } from "../types";

/**
 * User data reducer function.
 * 
 * @param {*} state Redux state as app wide store (initial state is empty)
 * @param {*} action which action is then processing
 * @returns state
 */
export default function userReducer(state = {}, action) {
  switch (action.type) {
    // Get user data from Server
    case GET_USERDATA:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
